

import { useState, useEffect } from "react";
import Config from "../../Config";


import InputText from "../../helpers/InputText";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputPostCode from "../../helpers/InputPostCode";
import InputEmail from "../../helpers/InputEmail";
import InputPhone from "../../helpers/InputPhone";
import InputUploader from "../../helpers/InputUploader";
import InputTime from "../../helpers/InputTime";
import InputNIP from "../../helpers/InputNIP";
import InputREGON from "../../helpers/InputREGON";
import InputDecimal from "../../helpers/InputDecimal";



function Info(props)
{
        


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);

    const [checked, setChecked] = useState(false);
    const handleChange = () => {
        setChecked(!checked);
      };

    
 
    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }



    
    const valChange = (filedName, val, correct, msg) => {

        //  console.log("valChange: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
        setTab( {...tab, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }

    const goNext = () => {
        console.log("goNext");
    }

    const getData = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1,place', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') setTab(res);   
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const saveData = () => {

     
 
        if(!valChecker(tab))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }
 
        
        props.mainView.setProgress(-2);

        fetch( Config.url + '/rest_v1,place_update', {
            method: 'POST', 
            body: JSON.stringify(tab), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    //  
                    props.mainView.setProgress(-1);

                    if(res.status != null && res.status == 'OK')
                    {
                        props.mainView.showDialog( props.userData.dic.dlg_notice , props.userData.dic.dlg_sukcess , "ok" , null);
                    }else
                    {
                        props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_wrong  ,  "ok"  ,null); 
                    }

         } )
         .catch(err => {
                    props.mainView.setProgress(-1);
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }


    const completeUpload = (fileName, crypt) => {

        console.log("completeUpload " + fileName + " " + crypt);
        getData();
 
    }


    
    if(tab == null)
    {
        setTab([]);
        getData();
        return (
            <div></div>
        );        
    }

    if(tab._sys_ == undefined) //no correct response..
    {
        return (
            <div></div>
        );   
    }


    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        getData();
    }

 
   

    return (
        <div className="view_content">

         


             <form className="eForm bg_center">


                 

                   <div className="form_control">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                <img className="pl_logo" src={ "data:image/jpeg;base64, " + tab.logo} />
                                </td>
                                <td>
                                <InputUploader   userData={props.userData}  typ="logo_przedszkola" typId={tab.id} remove="1" completeUpload={completeUpload} title={props.userData.dic.fr_logo} max_files="1" ext="image/png, image/jpeg" />
                                </td>
                            </tr>
                        </tbody>                        
                    </table>
                                
                                
                     </div>

                 
                     <div className="form_split"></div>
 


                    <div className="form_tab">

                            <div className="form_tab_title">{props.userData.dic.fr_baseData}
                                &nbsp;
                                <label className="switch" title={props.userData.dic.showmore}>                               
                                        <input type="checkbox" checked={checked}  onChange={handleChange}/>
                                        <span className="slider round"></span>
                                    </label>  
                            </div>

                            <div className="form_control">
                                <div className="fieldName">{props.userData.dic.fr_pl_name}*</div>
                                <InputText   userData={props.userData} value={tab.nazwa} valChange={valChange} goNext={goNext} name="nazwa" placeholder={props.userData.dic.fr_pl_name + ": "} className=' w300 ' req='1' />
                            </div>

                            <div className="form_control">
                                <div className="fieldName">{props.userData.dic.fr_pl_short}</div>
                                <InputText    userData={props.userData} value={tab.skrot_nazwy} valChange={valChange} goNext={goNext} name="skrot_nazwy" placeholder={props.userData.dic.fr_pl_short + ": "} className=' w200' req='0' />
                            </div>

                            <div className="form_split"></div>

                            <div className="form_control">
                                <div className="fieldName">{props.userData.dic.fr_street}*</div>
                                <InputTextAlpha   userData={props.userData}   value={tab.ulica} valChange={valChange} goNext={goNext} name="ulica" placeholder={props.userData.dic.fr_street + ": "} className=' w250' req='1' />
                            </div>

                            <div className="form_control">
                                <div className="fieldName">{props.userData.dic.fr_house_num}*</div>
                                <InputText  userData={props.userData}  value={tab.nr_domu} valChange={valChange} goNext={goNext} name="nr_domu" placeholder={props.userData.dic.fr_house_num + ": "} className=' w50' req='1' />
                            </div>

                            
                            <div className="form_control">
                                <div className="fieldName">{props.userData.dic.fr_flat_num}</div>
                                <InputText    userData={props.userData}  value={tab.nr_mieszkania} valChange={valChange} goNext={goNext} name="nr_mieszkania" placeholder={props.userData.dic.fr_flat_num + ": "} className=' w50' req='0' />
                            </div>

                            <div className="form_split"></div>

                            <div className="form_control">
                                <div className="fieldName">{props.userData.dic.fr_post_code}*</div>
                                <InputPostCode   userData={props.userData}  value={tab.kod_pocztowy} valChange={valChange} goNext={goNext} name="kod_pocztowy" placeholder={props.userData.dic.fr_post_code + ": "} className=' w50' req='1' />
                            </div>

                            
                            <div className="form_control">
                                <div className="fieldName">{props.userData.dic.fr_city}*</div>
                                <InputTextAlpha   userData={props.userData}  value={tab.miasto} valChange={valChange} goNext={goNext} name="miasto" placeholder={props.userData.dic.fr_city + ": "} className=' w150' req='1' firstUp="1" />
                            </div>



                            <div className="form_control">
                                <div className="fieldName">{props.userData.dic.fr_nip}*</div>
                                <InputNIP   userData={props.userData}  value={tab.nip} valChange={valChange} goNext={goNext} name="nip" placeholder={props.userData.dic.fr_nip + ": "} className=' w150' req='1'   />
                            </div>

                            { checked &&
                                <div className="form_control">
                                    <div className="fieldName">{props.userData.dic.fr_regon}*</div>
                                    <InputREGON   userData={props.userData}  value={tab.regon} valChange={valChange} goNext={goNext} name="regon" placeholder={props.userData.dic.fr_regon + ": "} className=' w150' req='0'  />
                                </div>
                            }


                            <div className="form_split"></div>

                            <div className="form_control">
                                <div className="fieldName">{props.userData.dic.fr_e_mail}*</div>
                                <InputEmail    userData={props.userData} value={tab.e_mail} valChange={valChange} goNext={goNext} name="e_mail" placeholder={props.userData.dic.fr_e_mail + ": "} className=' w250' req='1' />
                            </div>

                            
                            <div className="form_control">
                                <div className="fieldName">{props.userData.dic.fr_phone}*</div>
                                <InputPhone    userData={props.userData}  value={tab.telefon_kontaktowy} valChange={valChange} goNext={goNext} name="telefon_kontaktowy" placeholder={props.userData.dic.fr_phone + ": "} className=' w100' req='1' />
                            </div>

                            { checked &&
                            
                                <div>
                                        <div className="form_control">
                                            <div className="fieldName">{props.userData.dic.fr_name}*</div>
                                            <InputTextAlpha    userData={props.userData}  value={tab.imie_dyrektor} valChange={valChange} goNext={goNext} name="imie_dyrektor" placeholder={props.userData.dic.fr_name + ": "} className=' w100' req='1' firstUp="1"  />
                                        </div>

                                        <div className="form_control">
                                            <div className="fieldName">{props.userData.dic.fr_last_name}*</div>
                                            <InputTextAlpha    userData={props.userData}  value={tab.nazwisko_dyrektor} valChange={valChange} goNext={goNext} name="nazwisko_dyrektor" placeholder={props.userData.dic.fr_last_name + ": "} className=' w100' req='1'  firstUp="1"  />
                                        </div>


                                     

                                </div>
                            }

                    </div>                            

                  

                    <div className="form_tab">

                            <div className="form_tab_title">{props.userData.dic.fr_hours}</div>

                            <div className="form_control">
                                <div className="fieldName">{props.userData.dic.fr_hours_open}*</div>
                                <InputTime   userData={props.userData} value={tab.otwarte_od} valChange={valChange} goNext={goNext} name="otwarte_od" placeholder={props.userData.dic.fr_hours_open + ": "} className='  ' req='1' />
                            </div>

                            <div className="form_control">
                                <div className="fieldName">{props.userData.dic.fr_hours_close}*</div>
                                <InputTime   userData={props.userData} value={tab.otwarte_do} valChange={valChange} goNext={goNext} name="otwarte_do" placeholder={props.userData.dic.fr_hours_close + ": "} className='  ' req='1' />
                            </div>

                            { checked &&
                                                        
                                <div className="form_control">
                                    <div className="fieldName">{props.userData.dic.fr_hours_open_sat}</div>
                                    <InputTime   userData={props.userData} value={tab.sb_otwarte_od} valChange={valChange} goNext={goNext} name="sb_otwarte_od" placeholder={props.userData.dic.fr_hours_open_sat + ": "} className='  ' req='0' />
                                </div>
                            }

                            { checked &&
                                <div className="form_control">
                                    <div className="fieldName">{props.userData.dic.fr_hours_close_sat}</div>
                                    <InputTime   userData={props.userData} value={tab.sb_otwarte_do} valChange={valChange} goNext={goNext} name="sb_otwarte_do" placeholder={props.userData.dic.fr_hours_close_sat + ": "} className='  ' req='0' />
                                </div>
                            }


                            { checked &&
                                                        
                                <div className="form_control">
                                    <div className="fieldName">{props.userData.dic.fr_hours_open_sun}</div>
                                    <InputTime   userData={props.userData} value={tab.nd_otwarte_od} valChange={valChange} goNext={goNext} name="nd_otwarte_od" placeholder={props.userData.dic.fr_hours_open_sun + ": "} className='  ' req='0' />
                                </div>
                            }
                        
                            { checked &&
                                <div className="form_control">
                                    <div className="fieldName">{props.userData.dic.fr_hours_close_sun}</div>
                                    <InputTime   userData={props.userData} value={tab.nd_otwarte_do} valChange={valChange} goNext={goNext} name="nd_otwarte_do" placeholder={props.userData.dic.fr_hours_close_sun + ": "} className='  ' req='0' />
                                </div>
                            }
                                
                            

                    </div>

                    { checked &&
                        <div className="form_tab">
                            <div className="form_tab_title">{props.userData.dic.fr_location}</div>

                            <div className="form_control">
                                    <div className="fieldName">{props.userData.dic.fr_location_lat}</div>
                                    <InputDecimal   userData={props.userData} value={tab.lat} valChange={valChange} goNext={goNext} name="lat" placeholder={props.userData.dic.fr_location_lat + ": "} className='  ' maxDec='5' />
                            </div>

                            <div className="form_control">
                                    <div className="fieldName">{props.userData.dic.fr_location_lng}</div>
                                    <InputDecimal   userData={props.userData} value={tab.lng} valChange={valChange} goNext={goNext} name="lng" placeholder={props.userData.dic.fr_location_lng + ": "} className='  '  maxDec='5'  />
                            </div>

                        </div>
                    }

     

                    <div className="form_split"></div>

                    <div className="form_btn">
                            <div className="btn" onClick={saveData}>{props.userData.dic.save}</div>
                    </div>
                  


             </form>

        </div>
    )
}



export default Info;